/* tslint:disable */
/* eslint-disable */
// @ts-ignore
import * as Types from '../../../../global-graphql-types'

import { DocumentNode } from 'graphql'
import * as Apollo from '@apollo/client'
import * as ApolloReactHooks from 'utils/extendApolloHooks'
const defaultOptions = {} as const
export type CateringRequestCreateVariables = Types.Exact<{
  address: Types.Scalars['String']
  startAt: Types.Scalars['DateTime']
  endAt: Types.Scalars['DateTime']
  cateringType: Types.Scalars['String']
  additionalInstructions: Types.InputMaybe<Types.Scalars['String']>
  foodPreferences: Types.InputMaybe<Types.Scalars['String']>
  attendees: Types.Scalars['Int']
  customerTotalBudget: Types.Scalars['Int']
  mealParts: Array<Types.MealPartsInput> | Types.MealPartsInput
  organizationId: Types.InputMaybe<Types.Scalars['Int']>
  preferredTruckId: Types.InputMaybe<Types.Scalars['Int']>
  creationNote: Types.InputMaybe<Types.Scalars['String']>
  quoteOnly: Types.InputMaybe<Types.Scalars['Boolean']>
  copyFrom: Types.InputMaybe<Types.Scalars['Int']>
  preferredContactMethod: Types.InputMaybe<Types.CateringPreferredContactMethod>
  draft: Types.InputMaybe<Types.Scalars['Boolean']>
  fixedLocation: Types.InputMaybe<Types.Scalars['Boolean']>
}>

export type CateringRequestCreate = {
  __typename: 'Root'
  cateringRequestCreate: {
    __typename: 'CateringRequestCreatePayload'
    draft: boolean | null
    cateringRequest: {
      __typename: 'CateringRequest'
      id: number
      code: string
      enableAlcoholCatering: boolean
      customerTotalBudget: { __typename: 'Money'; cents: number }
      market: { __typename: 'Market'; id: number }
    } | null
    errors: Array<{
      __typename: 'UserError'
      fullMessage: string | null
      key: string | null
      message: string | null
      data: string | null
    }> | null
  } | null
}

export const CateringRequestCreateDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CateringRequestCreate' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'address' }
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
          }
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'startAt' }
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'DateTime' }
            }
          }
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'endAt' }
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'DateTime' }
            }
          }
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'cateringType' }
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
          }
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'additionalInstructions' }
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'foodPreferences' }
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'attendees' }
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } }
          }
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'customerTotalBudget' }
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } }
          }
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'mealParts' }
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: {
                  kind: 'NamedType',
                  name: { kind: 'Name', value: 'MealPartsInput' }
                }
              }
            }
          }
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'organizationId' }
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } }
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'preferredTruckId' }
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } }
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'creationNote' }
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'quoteOnly' }
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } }
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'copyFrom' }
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } }
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'preferredContactMethod' }
          },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'CateringPreferredContactMethod' }
          }
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'draft' }
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } }
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'fixedLocation' }
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'cateringRequestCreate' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'address' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'address' }
                }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'startAt' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'startAt' }
                }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'endAt' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'endAt' }
                }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'cateringType' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'cateringType' }
                }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'additionalInstructions' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'additionalInstructions' }
                }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'foodPreferences' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'foodPreferences' }
                }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'attendees' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'attendees' }
                }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'customerTotalBudgetCents' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'customerTotalBudget' }
                }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'mealParts' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'mealParts' }
                }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'organizationId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'organizationId' }
                }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'preferredTruckId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'preferredTruckId' }
                }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'creationNote' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'creationNote' }
                }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'quoteOnly' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'quoteOnly' }
                }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'copyFrom' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'copyFrom' }
                }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'preferredContactMethod' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'preferredContactMethod' }
                }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'draft' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'draft' }
                }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'fixedLocation' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'fixedLocation' }
                }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'cateringRequest' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'enableAlcoholCatering' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'customerTotalBudget' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'cents' }
                            }
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'market' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' }
                            }
                          ]
                        }
                      }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'draft' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'errors' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'fullMessage' }
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'message' }
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'data' } }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode
export type CateringRequestCreateMutationFn = Apollo.MutationFunction<
  CateringRequestCreate,
  CateringRequestCreateVariables
>

/**
 * __useCateringRequestCreate__
 *
 * To run a mutation, you first call `useCateringRequestCreate` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCateringRequestCreate` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cateringRequestCreate, { data, loading, error }] = useCateringRequestCreate({
 *   variables: {
 *      address: // value for 'address'
 *      startAt: // value for 'startAt'
 *      endAt: // value for 'endAt'
 *      cateringType: // value for 'cateringType'
 *      additionalInstructions: // value for 'additionalInstructions'
 *      foodPreferences: // value for 'foodPreferences'
 *      attendees: // value for 'attendees'
 *      customerTotalBudget: // value for 'customerTotalBudget'
 *      mealParts: // value for 'mealParts'
 *      organizationId: // value for 'organizationId'
 *      preferredTruckId: // value for 'preferredTruckId'
 *      creationNote: // value for 'creationNote'
 *      quoteOnly: // value for 'quoteOnly'
 *      copyFrom: // value for 'copyFrom'
 *      preferredContactMethod: // value for 'preferredContactMethod'
 *      draft: // value for 'draft'
 *      fixedLocation: // value for 'fixedLocation'
 *   },
 * });
 */
export function useCateringRequestCreate(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    CateringRequestCreate,
    CateringRequestCreateVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    CateringRequestCreate,
    CateringRequestCreateVariables
  >(CateringRequestCreateDocument, options)
}
export type CateringRequestCreateHookResult = ReturnType<
  typeof useCateringRequestCreate
>
export type CateringRequestCreateMutationResult =
  Apollo.MutationResult<CateringRequestCreate>
export type CateringRequestCreateMutationOptions = Apollo.BaseMutationOptions<
  CateringRequestCreate,
  CateringRequestCreateVariables
>
